import block from 'bem-cn-lite';
import {Avatar, Button, Icon, Popup, Text} from '@gravity-ui/uikit';
import {CircleRuble, Box, ShoppingCart} from '@gravity-ui/icons';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {AppContext} from '@app/context';
import {useContext, useState} from 'react';
import {usePopoverAuxControls} from '@frontend/shared';
import UserCard from '@components/Header/components/UserCard/UserCard';
import {ModalQuit} from '@components/ModalQuit';
import {useMenuKeyboard} from '@hooks/keyboard';

import './NavigationBottomMenu.scss';

const b = block('navigation-bottom-menu');

export const NavigationBottomMenu = () => {
    const {
        state: {user, basket},
        emit
    } = useContext(AppContext);
    const {open, buttonRef, toggleOpen, closePopover} = usePopoverAuxControls();
    const [showModalQuit, setShowModalQuit] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogoutRequest = () => {
        closePopover();
        setShowModalQuit(true);
    };

    const {highlightedIndex: profileMenuIndex} = useMenuKeyboard({
        isOpen: open,
        items: ['profile', 'logout'] as const,
        onSelect: (item) => {
            if (item === 'profile') {
                navigate('/profile');
                closePopover();
            } else {
                handleLogoutRequest();
            }
        },
        onClose: closePopover
    });

    const basketItemCount =
        basket.items.filter((item) => item.status === 'actual' || item.status === 'stale').length ||
        0;

    const isActiveRoute = (path: string) => {
        return location.pathname === path;
    };

    return (
        <div className={b()}>
            <Link to="/balance">
                <Button view="normal" size="xl" selected={isActiveRoute('/balance')}>
                    <Icon data={CircleRuble} width={20} height={20} />
                </Button>
            </Link>

            <Link to="/orders">
                <Button view="normal" size="xl" selected={isActiveRoute('/orders')}>
                    <Icon data={Box} width={20} height={20} />
                </Button>
            </Link>

            <Link to="/basket" className={b('basket-btn')}>
                <Button view="normal" size="xl" selected={isActiveRoute('/basket')}>
                    <Text className={b('quantity', {hidden: !basketItemCount})}>
                        {basketItemCount}
                    </Text>
                    <ShoppingCart className={b('icon')} />
                </Button>
            </Link>

            <div
                ref={buttonRef}
                className={b('avatar-trigger')}
                onClick={toggleOpen}
                role="button"
                tabIndex={0}
                aria-haspopup="dialog"
                aria-expanded={open}
                aria-label="Профиль"
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        toggleOpen();
                    }
                    if (event.key === 'Escape' && open) {
                        event.preventDefault();
                        closePopover();
                    }
                }}
            >
                <Avatar text={user?.displayName} theme="brand" size="l" />
            </div>

            <Popup
                anchorRef={buttonRef}
                onClose={closePopover}
                open={open}
                placement="top-start"
                hasArrow
                style={{borderRadius: '8px'}}
            >
                <UserCard
                    onClose={closePopover}
                    onLogoutRequest={handleLogoutRequest}
                    highlightedIndex={profileMenuIndex}
                />
            </Popup>

            <ModalQuit
                visibility={showModalQuit}
                stateModal={setShowModalQuit}
                positiveAction={() => emit('logout', {redirectTo: '/'})}
            />
        </div>
    );
};
